// Enhanced Mega Menu Data - Universal Single File
// Works in both Shopify (browser globals) and Next.js (ES modules)

const menuData = {
  "version": "9.0.0",
  "lastUpdated": new Date().toISOString(),
  "data": {
    "menu_selector": "enhanced-mega-menu",
    // ... your complete menu data here
  }
};

// Browser/Shopify mode - assign to window
if (typeof window !== 'undefined') {
  window.customMenuData = menuData;
  console.log("🚀 Loading Enhanced Mega Menu Data v9.0 - Browser Mode");
}

// Next.js/Node.js mode - only use exports when NOT in browser
// This prevents the export syntax error in Shopify
if (typeof window === 'undefined') {
  // We're in Node.js (Next.js server/build time)
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { customMenuData: menuData };
  }
  
  // For ES6 imports during build time
  if (typeof exports !== 'undefined') {
    exports.customMenuData = menuData;
  }
}

// This will only execute during Next.js build/import time, not in browser
try {
  if (typeof module !== 'undefined') {
    // Use a function to avoid syntax errors in browser
    eval('exports.customMenuData = menuData');
  }
} catch (e) {
  // Silently fail in browser - this is expected
}

window.customMenuData = {
  "version": "9.0.0",
  "lastUpdated": new Date().toISOString(),
  "data": {
    "menu_selector": "enhanced-mega-menu",
    "theme_selector": "camping-australia",
    "transition": "slide-fade",
    "trigger": "hover_intent",
    "show_indicator": true,
    "show_mobile_indicator": true,
    "menu_height": "auto",
    "alignment": "center",
    "root_padding": "0",
    "submenu_fullwidth": true,
    "performance_mode": true,
    "accessibility": true,
    "analytics_enabled": true,
    "megamenu": [
      {
        "id": "home-menu",
        "setting": {
          "item_layout": "enhanced",
          "submenu_type": "none",
          "title": "Home",
          "priority": 1,
          "url": {
            "type": {
              "id": "home",
              "name": "Home page"
            }
          }
        },
        "menus": []
      },
      {
        "id": "camping-menu",
        "setting": {
          "item_layout": "enhanced",
          "submenu_type": "mega",
          "submenu_mega_position": "fullwidth",
          "title": "Camping",
          "description": "Essential camping gear for every adventure",
          "submenu_tab_position": "left",
          "featured": true,
          "priority": 2
        },
        "menus": [
          {
            "id": "tents-shelters",
            "setting": {
              "item_layout": "enhanced",
              "title": "Tents & Shelters",
              "description": "Premium tents for every adventure",
              "featured": true,
              "priority": 1,
              "url": {
                "type": {
                  "id": "collection",
                  "name": "Collection"
                },
                "collection": {
                  "handle": "tents",
                  "title": "Tents"
                }
              }
            },
            "menus": [
              {"id": "tents", "setting": {"title": "All Tents", "url": {"type": {"id": "collection"}, "collection": {"handle": "tents"}}}},
              {"id": "hiking-tents", "setting": {"title": "Hiking Tents", "url": {"type": {"id": "collection"}, "collection": {"handle": "hiking-tents"}}}},
              {"id": "family-tents", "setting": {"title": "Family Tents", "url": {"type": {"id": "collection"}, "collection": {"handle": "family-tents"}}}},
              {"id": "dome-tents", "setting": {"title": "Dome Tents", "url": {"type": {"id": "collection"}, "collection": {"handle": "dome-tents"}}}},
              {"id": "touring-tents", "setting": {"title": "Touring Tents", "url": {"type": {"id": "collection"}, "collection": {"handle": "touring-tents"}}}},
              {"id": "rooftop-tents", "setting": {"title": "Rooftop Tents", "url": {"type": {"id": "collection"}, "collection": {"handle": "rooftop-tents"}}}},
              {"id": "haven-tents", "setting": {"title": "Haven Tents", "url": {"type": {"id": "collection"}, "collection": {"handle": "haven-tent"}}}},
              {"id": "haven-tents-accessories", "setting": {"title": "Haven Tents & Accessories", "url": {"type": {"id": "collection"}, "collection": {"handle": "haven-tents-accessories"}}}},
              {"id": "shower-ensuite-tents", "setting": {"title": "Shower & Ensuite Tents", "url": {"type": {"id": "collection"}, "collection": {"handle": "shower-ensuite-tents"}}}},
              {"id": "gazebos-shelters", "setting": {"title": "Gazebos & Shelters", "url": {"type": {"id": "collection"}, "collection": {"handle": "gazebos-shelters"}}}},
              {"id": "force-ten", "setting": {"title": "Force Ten", "url": {"type": {"id": "collection"}, "collection": {"handle": "force-ten"}}}},
              {"id": "vango", "setting": {"title": "Vango", "url": {"type": {"id": "collection"}, "collection": {"handle": "vango"}}}},
              {"id": "nortent", "setting": {"title": "Nortent", "url": {"type": {"id": "collection"}, "collection": {"handle": "nortent"}}}}
            ]
          },
          {
            "id": "swags",
            "setting": {
              "item_layout": "enhanced",
              "title": "Swags",
              "description": "Traditional Australian swags",
              "priority": 2,
              "url": {
                "type": {
                  "id": "collection",
                  "name": "Collection"
                },
                "collection": {
                  "handle": "swags",
                  "title": "Swags"
                }
              }
            },
            "menus": [
              {"id": "swags", "setting": {"title": "All Swags", "url": {"type": {"id": "collection"}, "collection": {"handle": "swags"}}}},
              {"id": "single-swags", "setting": {"title": "Single Swags", "url": {"type": {"id": "collection"}, "collection": {"handle": "single-swags"}}}},
              {"id": "double-swags", "setting": {"title": "Double Swags", "url": {"type": {"id": "collection"}, "collection": {"handle": "double-swags"}}}},
              {"id": "cranky-croc", "setting": {"title": "Cranky Croc", "url": {"type": {"id": "collection"}, "collection": {"handle": "cranky-croc"}}}},
              {"id": "weisshorn", "setting": {"title": "Weisshorn", "url": {"type": {"id": "collection"}, "collection": {"handle": "weisshorn"}}}}
            ]
          },
          {
            "id": "shade-protection",
            "setting": {
              "item_layout": "enhanced",
              "title": "Shade & Protection",
              "description": "Protection from sun and elements",
              "priority": 3,
              "url": {
                "type": {
                  "id": "collection",
                  "name": "Collection"
                },
                "collection": {
                  "handle": "gazebos-shade",
                  "title": "Shade & Protection"
                }
              }
            },
            "menus": [
              {"id": "gazebos-shade", "setting": {"title": "Gazebos & Shade", "url": {"type": {"id": "collection"}, "collection": {"handle": "gazebos-shade"}}}},
              {"id": "beach-shade", "setting": {"title": "Beach Shade", "url": {"type": {"id": "collection"}, "collection": {"handle": "beach-shade"}}}},
              {"id": "camping-tarps", "setting": {"title": "Camping Tarps", "url": {"type": {"id": "collection"}, "collection": {"handle": "camping-tarps"}}}},
              {"id": "outdoor-umbrellas", "setting": {"title": "Outdoor Umbrellas", "url": {"type": {"id": "collection"}, "collection": {"handle": "outdoor-umbrellas"}}}},
              {"id": "sunshade-sails", "setting": {"title": "Sunshade Sails", "url": {"type": {"id": "collection"}, "collection": {"handle": "sunshade-sails"}}}},
              {"id": "patio-outdoors-shade", "setting": {"title": "Patio & Outdoors Shade", "url": {"type": {"id": "collection"}, "collection": {"handle": "patio-outdoors-shade"}}}},
              {"id": "outdoors-shade", "setting": {"title": "Outdoors Shade", "url": {"type": {"id": "collection"}, "collection": {"handle": "outdoors-shade"}}}},
              {"id": "screening", "setting": {"title": "Screening", "url": {"type": {"id": "collection"}, "collection": {"handle": "screening"}}}}
            ]
          },
          {
            "id": "camp-cooking",
            "setting": {
              "item_layout": "enhanced",
              "title": "Camp Cooking",
              "description": "Everything for outdoor cooking",
              "priority": 4,
              "url": {
                "type": {
                  "id": "collection",
                  "name": "Collection"
                },
                "collection": {
                  "handle": "camp-cooking-equipment",
                  "title": "Camp Cooking"
                }
              }
            },
            "menus": [
              {"id": "camp-cooking-equipment", "setting": {"title": "Camp Cooking Equipment", "url": {"type": {"id": "collection"}, "collection": {"handle": "camp-cooking-equipment"}}}},
              {"id": "portable-stoves", "setting": {"title": "Portable Stoves", "url": {"type": {"id": "collection"}, "collection": {"handle": "portable-stoves"}}}},
              {"id": "cookware", "setting": {"title": "Cookware", "url": {"type": {"id": "collection"}, "collection": {"handle": "cookware"}}}},
              {"id": "cast-iron-camp-ovens", "setting": {"title": "Cast Iron Camp Ovens", "url": {"type": {"id": "collection"}, "collection": {"handle": "cast-iron-camp-ovens"}}}},
              {"id": "camp-coffee-essentials", "setting": {"title": "Camp Coffee Essentials", "url": {"type": {"id": "collection"}, "collection": {"handle": "camp-coffee-essentials"}}}},
              {"id": "cooking-utensils", "setting": {"title": "Cooking Utensils", "url": {"type": {"id": "collection"}, "collection": {"handle": "cooking-utensils"}}}},
              {"id": "pots-pans", "setting": {"title": "Pots & Pans", "url": {"type": {"id": "collection"}, "collection": {"handle": "pots-pans"}}}},
              {"id": "drinkware", "setting": {"title": "Drinkware", "url": {"type": {"id": "collection"}, "collection": {"handle": "drinkware"}}}},
              {"id": "coolers", "setting": {"title": "Coolers", "url": {"type": {"id": "collection"}, "collection": {"handle": "coolers"}}}},
              {"id": "tumblers", "setting": {"title": "Tumblers", "url": {"type": {"id": "collection"}, "collection": {"handle": "tumblers"}}}},
              {"id": "cup-holders", "setting": {"title": "Cup Holders", "url": {"type": {"id": "collection"}, "collection": {"handle": "cup-holders"}}}},
              {"id": "aeropress", "setting": {"title": "AeroPress", "url": {"type": {"id": "collection"}, "collection": {"handle": "aeropress"}}}},
              {"id": "hiking-cooking", "setting": {"title": "Hiking Cooking", "url": {"type": {"id": "collection"}, "collection": {"handle": "hiking-cooking"}}}},
              {"id": "tramontina", "setting": {"title": "Tramontina Knives", "url": {"type": {"id": "collection"}, "collection": {"handle": "tramontina-knives"}}}},
              {"id": "outdoor-knives", "setting": {"title": "Outdoor Knives", "url": {"type": {"id": "collection"}, "collection": {"handle": "outdoor-knives"}}}}
            ]
          },
          {
            "id": "camping-furniture",
            "setting": {
              "item_layout": "enhanced",
              "title": "Camping Furniture",
              "description": "Comfort for your campsite",
              "priority": 5,
              "url": {
                "type": {
                  "id": "collection",
                  "name": "Collection"
                },
                "collection": {
                  "handle": "camping-furniture",
                  "title": "Camping Furniture"
                }
              }
            },
            "menus": [
              {"id": "camping-furniture", "setting": {"title": "All Camping Furniture", "url": {"type": {"id": "collection"}, "collection": {"handle": "camping-furniture"}}}},
              {"id": "camping-chairs", "setting": {"title": "Camping Chairs", "url": {"type": {"id": "collection"}, "collection": {"handle": "camping-chairs"}}}},
              {"id": "camping-tables", "setting": {"title": "Camping Tables", "url": {"type": {"id": "collection"}, "collection": {"handle": "camping-tables"}}}},
              {"id": "camping-hammocks", "setting": {"title": "Camping Hammocks", "url": {"type": {"id": "collection"}, "collection": {"handle": "camping-hammocks"}}}},
              {"id": "hammocks", "setting": {"title": "Hammocks", "url": {"type": {"id": "collection"}, "collection": {"handle": "hammocks"}}}},
              {"id": "chairs", "setting": {"title": "Chairs", "url": {"type": {"id": "collection"}, "collection": {"handle": "chairs"}}}}
            ]
          },
          {
            "id": "sleep-comfort",
            "setting": {
              "item_layout": "enhanced",
              "title": "Sleep & Comfort",
              "description": "Rest and comfort solutions",
              "priority": 6,
              "url": {
                "type": {
                  "id": "collection",
                  "name": "Collection"
                },
                "collection": {
                  "handle": "sleeping-bags",
                  "title": "Sleep & Comfort"
                }
              }
            },
            "menus": [
              {"id": "sleeping-bags", "setting": {"title": "Sleeping Bags", "url": {"type": {"id": "collection"}, "collection": {"handle": "sleeping-bags"}}}},
              {"id": "mattresses-sleeping-mats", "setting": {"title": "Mattresses & Sleeping Mats", "url": {"type": {"id": "collection"}, "collection": {"handle": "mattresses-sleeping-mats"}}}},
              {"id": "pillows-accessories", "setting": {"title": "Pillows & Accessories", "url": {"type": {"id": "collection"}, "collection": {"handle": "pillows-and-accessories"}}}},
              {"id": "bedding", "setting": {"title": "Bedding", "url": {"type": {"id": "collection"}, "collection": {"handle": "bedding"}}}},
              {"id": "blankets", "setting": {"title": "Blankets", "url": {"type": {"id": "collection"}, "collection": {"handle": "blankets"}}}}
            ]
          },
          {
            "id": "outdoor-apparel-gear",
            "setting": {
              "item_layout": "enhanced",
              "title": "Outdoor Apparel & Gear",
              "description": "Performance clothing and outdoor equipment",
              "priority": 7,
              "url": {
                "type": {
                  "id": "collection",
                  "name": "Collection"
                },
                "collection": {
                  "handle": "all-apparel",
                  "title": "Apparel"
                }
              }
            },
            "menus": [
              {"id": "all-apparel", "setting": {"title": "All Apparel", "url": {"type": {"id": "collection"}, "collection": {"handle": "all-apparel"}}}},
              {"id": "mens-jackets", "setting": {"title": "Men's Jackets and Coats", "url": {"type": {"id": "collection"}, "collection": {"handle": "mens-jacket-and-coats"}}}},
              {"id": "mens-shirts", "setting": {"title": "Men's Shirts", "url": {"type": {"id": "collection"}, "collection": {"handle": "mens-shirts"}}}},
              {"id": "womens-jackets", "setting": {"title": "Women's Jackets And Coats", "url": {"type": {"id": "collection"}, "collection": {"handle": "womens-jackets-and-coats"}}}},
              {"id": "hiking-clothing", "setting": {"title": "Hiking Clothing", "url": {"type": {"id": "collection"}, "collection": {"handle": "hiking-clothing"}}}},
              {"id": "hiking-boots", "setting": {"title": "Hiking Boots", "url": {"type": {"id": "collection"}, "collection": {"handle": "hiking-boots"}}}},
              {"id": "hiking-gear", "setting": {"title": "Hiking Gear", "url": {"type": {"id": "collection"}, "collection": {"handle": "hiking-gear"}}}},
              {"id": "hats", "setting": {"title": "Hats", "url": {"type": {"id": "collection"}, "collection": {"handle": "hats"}}}},
              {"id": "socks", "setting": {"title": "Socks", "url": {"type": {"id": "collection"}, "collection": {"handle": "socks"}}}},
              {"id": "thermals", "setting": {"title": "Thermals", "url": {"type": {"id": "collection"}, "collection": {"handle": "thermals"}}}},
              {"id": "hydration", "setting": {"title": "Hydration", "url": {"type": {"id": "collection"}, "collection": {"handle": "hydration"}}}},
              {"id": "walking-poles", "setting": {"title": "Walking Poles", "url": {"type": {"id": "collection"}, "collection": {"handle": "walking-poles"}}}},
              {"id": "bikes", "setting": {"title": "Bikes", "url": {"type": {"id": "collection"}, "collection": {"handle": "bikes"}}}},
              {"id": "smartwatches", "setting": {"title": "Smartwatches", "url": {"type": {"id": "collection"}, "collection": {"handle": "smartwatches"}}}},
              {"id": "outdoor-pet-care", "setting": {"title": "Outdoor Pet Care", "url": {"type": {"id": "collection"}, "collection": {"handle": "outdoor-pet-care"}}}},
              {"id": "metal-detectors", "setting": {"title": "Metal Detectors", "url": {"type": {"id": "collection"}, "collection": {"handle": "metal-detectors"}}}}
            ]
          },
          {
            "id": "snow-winter-gear",
            "setting": {
              "item_layout": "enhanced",
              "title": "Snow & Winter Gear",
              "description": "Complete winter sports equipment",
              "priority": 8,
              "url": {
                "type": {
                  "id": "collection",
                  "name": "Collection"
                },
                "collection": {
                  "handle": "ski-snow-gear",
                  "title": "Snow & Winter"
                }
              }
            },
            "menus": [
              {"id": "ski-snow-gear", "setting": {"title": "Ski & Snow Gear", "url": {"type": {"id": "collection"}, "collection": {"handle": "ski-snow-gear"}}}},
              {"id": "mens-snow-apparel", "setting": {"title": "Men's Snow Apparel", "url": {"type": {"id": "collection"}, "collection": {"handle": "mens-snow-apparel"}}}},
              {"id": "womens-snow-apparel", "setting": {"title": "Women's Snow Apparel", "url": {"type": {"id": "collection"}, "collection": {"handle": "womens-snow-apparel"}}}},
              {"id": "kids-snow-apparel", "setting": {"title": "Kid's Snow Apparel", "url": {"type": {"id": "collection"}, "collection": {"handle": "kids-snow-apparel"}}}},
              {"id": "mens-snow-boots", "setting": {"title": "Men's Snow Boots", "url": {"type": {"id": "collection"}, "collection": {"handle": "mens-snow-boots"}}}},
              {"id": "womens-snow-boots", "setting": {"title": "Women's Snow Boots", "url": {"type": {"id": "collection"}, "collection": {"handle": "womens-snow-boots"}}}},
              {"id": "kids-snow-boots", "setting": {"title": "Kid's Snow Boots", "url": {"type": {"id": "collection"}, "collection": {"handle": "kids-snow-boots"}}}},
              {"id": "alpine-skis", "setting": {"title": "Alpine Skis", "url": {"type": {"id": "collection"}, "collection": {"handle": "alpine-skis"}}}},
              {"id": "cross-country-skis", "setting": {"title": "Cross Country Skis", "url": {"type": {"id": "collection"}, "collection": {"handle": "cross-country-skis"}}}},
              {"id": "alpine-ski-poles", "setting": {"title": "Alpine Ski Poles", "url": {"type": {"id": "collection"}, "collection": {"handle": "alpine-ski-poles"}}}},
              {"id": "snow-goggles", "setting": {"title": "Snow Goggles", "url": {"type": {"id": "collection"}, "collection": {"handle": "snow-googles"}}}}
            ]
          },
          {
            "id": "camping-accessories",
            "setting": {
              "item_layout": "enhanced",
              "title": "Camping Accessories",
              "description": "Essential camping gear and accessories",
              "priority": 9,
              "url": {
                "type": {
                  "id": "collection",
                  "name": "Collection"
                },
                "collection": {
                  "handle": "camping",
                  "title": "Camping Accessories"
                }
              }
            },
            "menus": [
              {"id": "camping", "setting": {"title": "All Camping", "url": {"type": {"id": "collection"}, "collection": {"handle": "camping"}}}},
              {"id": "tent-accessories", "setting": {"title": "Tent Accessories", "url": {"type": {"id": "collection"}, "collection": {"handle": "tent-accessories"}}}},
              {"id": "tent-poles", "setting": {"title": "Tent Poles", "url": {"type": {"id": "collection"}, "collection": {"handle": "tent-poles"}}}},
              {"id": "camping-amenities", "setting": {"title": "Camping Amenities", "url": {"type": {"id": "collection"}, "collection": {"handle": "camping-amenities"}}}},
              {"id": "camping-toilet-shower", "setting": {"title": "Camping Toilet & Shower", "url": {"type": {"id": "collection"}, "collection": {"handle": "camping-toilet-and-shower"}}}},
              {"id": "portable-toilets", "setting": {"title": "Portable Toilets", "url": {"type": {"id": "collection"}, "collection": {"handle": "portable-toilets"}}}},
              {"id": "camping-torches-lanterns", "setting": {"title": "Camping Torches & Lanterns", "url": {"type": {"id": "collection"}, "collection": {"handle": "camping-torches-lanterns"}}}},
              {"id": "dry-bags", "setting": {"title": "Dry Bags", "url": {"type": {"id": "collection"}, "collection": {"handle": "dry-bags"}}}},
              {"id": "packs-bags", "setting": {"title": "Packs & Bags", "url": {"type": {"id": "collection"}, "collection": {"handle": "packs-bags"}}}},
              {"id": "cleaning-maintenance", "setting": {"title": "Cleaning & Maintenance", "url": {"type": {"id": "collection"}, "collection": {"handle": "cleaning-maintenance"}}}},
              {"id": "cleaning-chemicals-cloths", "setting": {"title": "Cleaning Chemicals & Cloths", "url": {"type": {"id": "collection"}, "collection": {"handle": "cleaning-chemicals-cloths"}}}},
              {"id": "laundry-accessories", "setting": {"title": "Laundry Accessories", "url": {"type": {"id": "collection"}, "collection": {"handle": "laundry-accessories"}}}},
              {"id": "water-tubs", "setting": {"title": "Water Tubs", "url": {"type": {"id": "collection"}, "collection": {"handle": "water-tubs"}}}},
              {"id": "picnic", "setting": {"title": "Picnic", "url": {"type": {"id": "collection"}, "collection": {"handle": "picnic"}}}},
              {"id": "beach-trolleys", "setting": {"title": "Beach Trolleys & Carts", "url": {"type": {"id": "collection"}, "collection": {"handle": "beach-trolleys-carts"}}}},
              {"id": "outdoors", "setting": {"title": "Outdoors", "url": {"type": {"id": "collection"}, "collection": {"handle": "outdoors"}}}}
            ]
          }
        ]
      },
      {
        "id": "caravan-rv-menu",
        "setting": {
          "item_layout": "enhanced",
          "submenu_type": "mega",
          "submenu_mega_position": "fullwidth",
          "title": "Caravan & RV",
          "description": "Complete caravan accessories and equipment",
          "submenu_tab_position": "left",
          "priority": 3
        },
        "menus": [
          {
            "id": "caravan-appliances",
            "setting": {
              "item_layout": "enhanced",
              "title": "Caravan Appliances",
              "description": "Power your adventures",
              "priority": 1,
              "url": {
                "type": {
                  "id": "collection",
                  "name": "Collection"
                },
                "collection": {
                  "handle": "caravan-appliances",
                  "title": "Caravan Appliances"
                }
              }
            },
            "menus": [
              {"id": "caravan-appliances", "setting": {"title": "All Caravan Appliances", "url": {"type": {"id": "collection"}, "collection": {"handle": "caravan-appliances"}}}},
              {"id": "caravan-upright-fridges", "setting": {"title": "Caravan Upright Fridges", "url": {"type": {"id": "collection"}, "collection": {"handle": "caravan-upright-fridges"}}}},
              {"id": "12-24-volt-fridges", "setting": {"title": "12/24 Volt Upright Fridges", "url": {"type": {"id": "collection"}, "collection": {"handle": "12-24-volt-upright-fridges"}}}},
              {"id": "12-24-240-volt-fridges", "setting": {"title": "12/24/240 Volt Upright Fridges", "url": {"type": {"id": "collection"}, "collection": {"handle": "12-24-240-volt-upright-fridges"}}}},
              {"id": "3-way-gas-fridges", "setting": {"title": "3 Way Gas Absorption Fridges", "url": {"type": {"id": "collection"}, "collection": {"handle": "3-way-gas-absorption-upright-fridges"}}}},
              {"id": "drawer-fridge-freezer", "setting": {"title": "Drawer Fridge/Freezer", "url": {"type": {"id": "collection"}, "collection": {"handle": "drawer-fridge-freezer"}}}},
              {"id": "portable-chest-fridges", "setting": {"title": "Portable Chest Fridges", "url": {"type": {"id": "collection"}, "collection": {"handle": "portable-chest-fridge-freezer"}}}},
              {"id": "single-zone-fridges", "setting": {"title": "Single Zone Portable Fridges", "url": {"type": {"id": "collection"}, "collection": {"handle": "single-zone-portable-fridge-freezer"}}}},
              {"id": "dual-zone-fridges", "setting": {"title": "Dual Zone Portable Fridges", "url": {"type": {"id": "collection"}, "collection": {"handle": "dual-zone-portable-fridge-freezer"}}}},
              {"id": "thermoelectric-coolers", "setting": {"title": "Thermoelectric Coolers", "url": {"type": {"id": "collection"}, "collection": {"handle": "thermoelectric-cooler-warmers"}}}},
              {"id": "fridge-slides-covers", "setting": {"title": "Fridge Slides & Covers", "url": {"type": {"id": "collection"}, "collection": {"handle": "fridge-slides-covers-tie-downs"}}}},
              {"id": "caravan-microwaves", "setting": {"title": "Caravan Microwaves & Rangehoods", "url": {"type": {"id": "collection"}, "collection": {"handle": "caravan-microwaves-rangehoods"}}}},
              {"id": "stoves-sinks-ovens", "setting": {"title": "Stoves, Sinks & Ovens", "url": {"type": {"id": "collection"}, "collection": {"handle": "stoves-sinks-ovens"}}}},
              {"id": "washing-machines", "setting": {"title": "Washing Machines & Dryers", "url": {"type": {"id": "collection"}, "collection": {"handle": "washing-machines-dryers"}}}},
              {"id": "dometic", "setting": {"title": "Dometic", "url": {"type": {"id": "collection"}, "collection": {"handle": "dometic"}}}},
              {"id": "thetford", "setting": {"title": "Thetford", "url": {"type": {"id": "collection"}, "collection": {"handle": "thetford"}}}},
              {"id": "mycoolman", "setting": {"title": "myCOOLMAN", "url": {"type": {"id": "collection"}, "collection": {"handle": "mycoolman"}}}},
              {"id": "national-luna", "setting": {"title": "National Luna", "url": {"type": {"id": "collection"}, "collection": {"handle": "national-luna"}}}}
            ]
          },
          {
            "id": "heating-hot-water",
            "setting": {
              "item_layout": "enhanced",
              "title": "Heating & Hot Water",
              "description": "Stay warm and comfortable",
              "priority": 2,
              "url": {
                "type": {
                  "id": "collection",
                  "name": "Collection"
                },
                "collection": {
                  "handle": "heaters-hot-water-systems",
                  "title": "Heating & Hot Water"
                }
              }
            },
            "menus": [
              {"id": "heaters-hot-water", "setting": {"title": "Heaters & Hot Water Systems", "url": {"type": {"id": "collection"}, "collection": {"handle": "heaters-hot-water-systems"}}}},
              {"id": "caravan-diesel-heaters", "setting": {"title": "Caravan Diesel Heaters", "url": {"type": {"id": "collection"}, "collection": {"handle": "caravan-diesel-heaters-hot-water-systems"}}}},
              {"id": "electric-hot-water", "setting": {"title": "Electric Hot Water Heaters", "url": {"type": {"id": "collection"}, "collection": {"handle": "electric-hot-water-heaters"}}}},
              {"id": "gas-hot-water", "setting": {"title": "Gas Hot Water Heaters", "url": {"type": {"id": "collection"}, "collection": {"handle": "gas-hot-water-heaters"}}}},
              {"id": "portable-gas-water", "setting": {"title": "Portable Gas Water Heaters", "url": {"type": {"id": "collection"}, "collection": {"handle": "portable-gas-water-heaters"}}}},
              {"id": "portable-air-conditioners", "setting": {"title": "Portable Air Conditioners", "url": {"type": {"id": "collection"}, "collection": {"handle": "portable-air-conditioners"}}}},
              {"id": "rooftop-air-conditioner", "setting": {"title": "Rooftop Air Conditioner", "url": {"type": {"id": "collection"}, "collection": {"handle": "rooftop-air-conditioner"}}}},
              {"id": "truma", "setting": {"title": "Truma", "url": {"type": {"id": "collection"}, "collection": {"handle": "truma"}}}}
            ]
          },
          {
            "id": "water-waste-systems",
            "setting": {
              "item_layout": "enhanced",
              "title": "Water & Waste Systems",
              "description": "Water management solutions",
              "priority": 3,
              "url": {
                "type": {
                  "id": "collection",
                  "name": "Collection"
                },
                "collection": {
                  "handle": "water-waste-holding-tanks",
                  "title": "Water & Waste Systems"
                }
              }
            },
            "menus": [
              {"id": "plumbing-tanks-fixtures", "setting": {"title": "Plumbing, Tanks & Fixtures", "url": {"type": {"id": "collection"}, "collection": {"handle": "plumbing-tanks-fixtures"}}}},
              {"id": "water-waste-tanks", "setting": {"title": "Water & Waste Holding Tanks", "url": {"type": {"id": "collection"}, "collection": {"handle": "water-waste-holding-tanks"}}}},
              {"id": "water-tanks", "setting": {"title": "Water Tanks", "url": {"type": {"id": "collection"}, "collection": {"handle": "water-tanks"}}}},
              {"id": "water-pumps", "setting": {"title": "Water Pumps", "url": {"type": {"id": "collection"}, "collection": {"handle": "water-pumps"}}}},
              {"id": "water-tank-accessories", "setting": {"title": "Water Tank Accessories", "url": {"type": {"id": "collection"}, "collection": {"handle": "water-tank-accessories"}}}}
            ]
          },
          {
            "id": "caravan-awnings",
            "setting": {
              "item_layout": "enhanced",
              "title": "Caravan Awnings",
              "description": "Shade and outdoor living",
              "priority": 4,
              "url": {
                "type": {
                  "id": "collection",
                  "name": "Collection"
                },
                "collection": {
                  "handle": "caravan-awnings",
                  "title": "Caravan Awnings"
                }
              }
            },
            "menus": [
              {"id": "caravan-awnings", "setting": {"title": "All Caravan Awnings", "url": {"type": {"id": "collection"}, "collection": {"handle": "caravan-awnings"}}}},
              {"id": "caravan-motorhome-awnings", "setting": {"title": "Caravan & Motorhome Awnings", "url": {"type": {"id": "collection"}, "collection": {"handle": "caravan-motorhome-awnings"}}}},
              {"id": "campervan-awnings", "setting": {"title": "Campervan Awnings", "url": {"type": {"id": "collection"}, "collection": {"handle": "campervan-awnings"}}}},
              {"id": "dometic-8700-awnings", "setting": {"title": "Dometic 8700 Awnings", "url": {"type": {"id": "collection"}, "collection": {"handle": "dometic-8700-awnings"}}}},
              {"id": "fiamma-f45-awnings", "setting": {"title": "Fiamma F45 L Awnings", "url": {"type": {"id": "collection"}, "collection": {"handle": "fiamma-f45-l-awnings"}}}},
              {"id": "caravan-privacy-screens", "setting": {"title": "Caravan & Motorhome Privacy Screens", "url": {"type": {"id": "collection"}, "collection": {"handle": "caravan-motorhome-privacy-screens"}}}},
              {"id": "fiamma-privacy-rooms", "setting": {"title": "Fiamma Privacy Rooms", "url": {"type": {"id": "collection"}, "collection": {"handle": "fiamma-privacy-rooms"}}}},
              {"id": "annexe-accessories", "setting": {"title": "Annexe Accessories", "url": {"type": {"id": "collection"}, "collection": {"handle": "annexe-accessories"}}}},
              {"id": "annexe-floor-matting", "setting": {"title": "Annexe Floor Matting", "url": {"type": {"id": "collection"}, "collection": {"handle": "annexe-floor-matting"}}}},
              {"id": "annexe-ground-cover", "setting": {"title": "Annexe Ground Cover Matting", "url": {"type": {"id": "collection"}, "collection": {"handle": "annexe-ground-cover-matting"}}}},
              {"id": "orbit-air-annexes", "setting": {"title": "Orbit Air Annexes", "url": {"type": {"id": "collection"}, "collection": {"handle": "orbit-air-annexes"}}}},
              {"id": "fiamma", "setting": {"title": "Fiamma", "url": {"type": {"id": "collection"}, "collection": {"handle": "fiamma"}}}},
              {"id": "carefree", "setting": {"title": "Carefree", "url": {"type": {"id": "collection"}, "collection": {"handle": "carefree"}}}}
            ]
          },
          {
            "id": "caravan-accessories",
            "setting": {
              "item_layout": "enhanced",
              "title": "Caravan Accessories",
              "description": "Essential caravan gear",
              "priority": 5,
              "url": {
                "type": {
                  "id": "collection",
                  "name": "Collection"
                },
                "collection": {
                  "handle": "caravan-accessories",
                  "title": "Caravan Accessories"
                }
              }
            },
            "menus": [
              {"id": "caravan-accessories", "setting": {"title": "All Caravan Accessories", "url": {"type": {"id": "collection"}, "collection": {"handle": "caravan-accessories"}}}},
              {"id": "caravan-security", "setting": {"title": "Caravan Security", "url": {"type": {"id": "collection"}, "collection": {"handle": "caravan-security"}}}},
              {"id": "caravan-steps", "setting": {"title": "Caravan Steps", "url": {"type": {"id": "collection"}, "collection": {"handle": "caravan-steps"}}}},
              {"id": "caravan-hardware", "setting": {"title": "Caravan Hardware", "url": {"type": {"id": "collection"}, "collection": {"handle": "caravan-hardware"}}}},
              {"id": "caravan-windows", "setting": {"title": "Caravan Windows", "url": {"type": {"id": "collection"}, "collection": {"handle": "caravan-windows"}}}},
              {"id": "access-doors-hatches", "setting": {"title": "Access Doors & Hatches", "url": {"type": {"id": "collection"}, "collection": {"handle": "access-doors-hatches"}}}},
              {"id": "roof-vents-skylights", "setting": {"title": "Roof Vents & Skylights", "url": {"type": {"id": "collection"}, "collection": {"handle": "roof-vents-skylights"}}}},
              {"id": "caravan-wall-tables", "setting": {"title": "Caravan Wall Mount Tables", "url": {"type": {"id": "collection"}, "collection": {"handle": "caravan-wall-mount-picnic-tables"}}}},
              {"id": "stabilisers-jockey", "setting": {"title": "Stabilisers & Jockey Wheels", "url": {"type": {"id": "collection"}, "collection": {"handle": "stabilisers-jockey-wheels"}}}},
              {"id": "wheel-chocks-levels", "setting": {"title": "Wheel Chocks & Level Ramps", "url": {"type": {"id": "collection"}, "collection": {"handle": "wheel-chocks-level-ramps"}}}},
              {"id": "electric-caravan-movers", "setting": {"title": "Electric Caravan Movers", "url": {"type": {"id": "collection"}, "collection": {"handle": "electric-caravan-movers"}}}},
              {"id": "jacks", "setting": {"title": "Jacks", "url": {"type": {"id": "collection"}, "collection": {"handle": "jacks"}}}},
              {"id": "camec", "setting": {"title": "CAMEC", "url": {"type": {"id": "collection"}, "collection": {"handle": "camec"}}}},
              {"id": "milenco", "setting": {"title": "Milenco", "url": {"type": {"id": "collection"}, "collection": {"handle": "milenco"}}}},
              {"id": "coast-to-coast", "setting": {"title": "Coast to Coast Rv", "url": {"type": {"id": "collection"}, "collection": {"handle": "coast-to-coast"}}}}
            ]
          },
          {
            "id": "caravan-covers",
            "setting": {
              "item_layout": "enhanced",
              "title": "Caravan Covers & Protection",
              "description": "Protect your investment",
              "priority": 6,
              "url": {
                "type": {
                  "id": "collection",
                  "name": "Collection"
                },
                "collection": {
                  "handle": "caravan-covers",
                  "title": "Caravan Covers"
                }
              }
            },
            "menus": [
              {"id": "caravans", "setting": {"title": "All Caravans", "url": {"type": {"id": "collection"}, "collection": {"handle": "caravans"}}}},
              {"id": "caravan-covers", "setting": {"title": "Caravan Covers", "url": {"type": {"id": "collection"}, "collection": {"handle": "caravan-covers"}}}},
              {"id": "motorhome-covers", "setting": {"title": "Motorhome Covers", "url": {"type": {"id": "collection"}, "collection": {"handle": "motorhome-covers"}}}},
              {"id": "pop-top-covers", "setting": {"title": "Pop-Top Caravan Covers", "url": {"type": {"id": "collection"}, "collection": {"handle": "pop-top-caravan-covers"}}}},
              {"id": "camper-trailer-covers", "setting": {"title": "Camper Trailer Covers", "url": {"type": {"id": "collection"}, "collection": {"handle": "camper-trailer-covers"}}}},
              {"id": "caravan-camper-covers", "setting": {"title": "Caravan & Camper Trailer Covers", "url": {"type": {"id": "collection"}, "collection": {"handle": "caravan-and-camper-trailer-covers"}}}},
              {"id": "trailer-covers", "setting": {"title": "Trailer Covers", "url": {"type": {"id": "collection"}, "collection": {"handle": "trailer-covers"}}}},
              {"id": "spare-wheel-covers", "setting": {"title": "Spare Wheel Covers", "url": {"type": {"id": "collection"}, "collection": {"handle": "spare-wheel-covers"}}}},
              {"id": "wheel-tyre-covers", "setting": {"title": "Wheel Tyre Guard Covers", "url": {"type": {"id": "collection"}, "collection": {"handle": "wheel-tyre-guard-covers"}}}}
            ]
          },
          {
            "id": "rv-technology",
            "setting": {
              "item_layout": "enhanced",
              "title": "RV Technology & Electronics",
              "description": "Advanced RV technology and entertainment",
              "priority": 7,
              "url": {
                "type": {
                  "id": "collection",
                  "name": "Collection"
                },
                "collection": {
                  "handle": "tvs-mounts-accessories",
                  "title": "RV Technology"
                }
              }
            },
            "menus": [
              {"id": "tvs-mounts-accessories", "setting": {"title": "TVs, Mounts & Accessories", "url": {"type": {"id": "collection"}, "collection": {"handle": "tvs-mounts-accessories"}}}},
              {"id": "tv-audio-antennas", "setting": {"title": "TV, Audio & Antennas", "url": {"type": {"id": "collection"}, "collection": {"handle": "tv-audio-antennas"}}}},
              {"id": "audio-sound-speakers", "setting": {"title": "Audio, Sound & Speakers", "url": {"type": {"id": "collection"}, "collection": {"handle": "audio-sound-speakers"}}}},
              {"id": "antennas-receivers", "setting": {"title": "Antenna's, Receivers & Satellites", "url": {"type": {"id": "collection"}, "collection": {"handle": "antennas-receivers-satellites"}}}},
              {"id": "rv-wifi", "setting": {"title": "RV Wi-Fi Systems", "url": {"type": {"id": "collection"}, "collection": {"handle": "rv-wi-fi-systems"}}}},
              {"id": "furrion", "setting": {"title": "Furrion", "url": {"type": {"id": "collection"}, "collection": {"handle": "furrion"}}}},
              {"id": "rosen-entertainment", "setting": {"title": "Rosen Entertainment", "url": {"type": {"id": "collection"}, "collection": {"handle": "rosen-entertainment"}}}},
              {"id": "winegard", "setting": {"title": "Winegard", "url": {"type": {"id": "collection"}, "collection": {"handle": "winegard"}}}},
              {"id": "cadence", "setting": {"title": "Cadence Car Audio", "url": {"type": {"id": "collection"}, "collection": {"handle": "cadence-car-audio"}}}}
            ]
          }
        ]
      },
      {
        "id": "4x4-touring-menu",
        "setting": {
          "item_layout": "enhanced",
          "submenu_type": "mega",
          "submenu_mega_position": "fullwidth",
          "title": "4x4 & Touring",
          "description": "Essential 4WD accessories for adventures",
          "submenu_tab_position": "left",
          "priority": 4
        },
        "menus": [
          {
            "id": "4x4-gear",
            "setting": {
              "item_layout": "enhanced",
              "title": "4x4 Gear",
              "description": "Essential 4WD equipment",
              "priority": 1,
              "url": {
                "type": {
                  "id": "collection",
                  "name": "Collection"
                },
                "collection": {
                  "handle": "4x4",
                  "title": "4x4 Gear"
                }
              }
            },
            "menus": [
              {"id": "4x4", "setting": {"title": "All 4x4", "url": {"type": {"id": "collection"}, "collection": {"handle": "4x4"}}}},
              {"id": "4x4-accessories", "setting": {"title": "4x4 Accessories", "url": {"type": {"id": "collection"}, "collection": {"handle": "4x4-accessories"}}}},
              {"id": "4wd-awnings", "setting": {"title": "4WD Awnings", "url": {"type": {"id": "collection"}, "collection": {"handle": "4wd-awnings"}}}},
              {"id": "270-awning", "setting": {"title": "270 Awning", "url": {"type": {"id": "collection"}, "collection": {"handle": "270-awning"}}}},
              {"id": "4x4-recovery-tracks", "setting": {"title": "4x4 Recovery Tracks", "url": {"type": {"id": "collection"}, "collection": {"handle": "4x4-recovery-tracks"}}}},
              {"id": "4x4-snorkels", "setting": {"title": "4x4 Snorkels", "url": {"type": {"id": "collection"}, "collection": {"handle": "4x4-snorkels"}}}},
              {"id": "4x4-winches", "setting": {"title": "4x4 Winches", "url": {"type": {"id": "collection"}, "collection": {"handle": "4x4-winches"}}}},
              {"id": "recovery-equipment", "setting": {"title": "Recovery Equipment", "url": {"type": {"id": "collection"}, "collection": {"handle": "recovery-equipment"}}}},
              {"id": "air-compressors", "setting": {"title": "Air Compressors", "url": {"type": {"id": "collection"}, "collection": {"handle": "air-compressors"}}}},
              {"id": "led-light-bars", "setting": {"title": "LED Light Bars & Driving Lights", "url": {"type": {"id": "collection"}, "collection": {"handle": "led-light-bars-driving-lights"}}}},
              {"id": "x-bull", "setting": {"title": "X-BULL", "url": {"type": {"id": "collection"}, "collection": {"handle": "x-bull"}}}}
            ]
          },
          {
            "id": "4x4-storage",
            "setting": {
              "item_layout": "enhanced",
              "title": "4x4 Storage & Organization",
              "description": "Storage solutions for 4WD",
              "priority": 2,
              "url": {
                "type": {
                  "id": "collection",
                  "name": "Collection"
                },
                "collection": {
                  "handle": "4x4-storage-drawers",
                  "title": "4x4 Storage"
                }
              }
            },
            "menus": [
              {"id": "4x4-storage-drawers", "setting": {"title": "4x4 Storage & Drawers", "url": {"type": {"id": "collection"}, "collection": {"handle": "4x4-storage-drawers"}}}},
              {"id": "4x4-storage-accessories", "setting": {"title": "4x4 Storage & Drawer Accessories", "url": {"type": {"id": "collection"}, "collection": {"handle": "4x4-storage-drawer-accessories"}}}},
              {"id": "storage-boxes", "setting": {"title": "Storage Boxes", "url": {"type": {"id": "collection"}, "collection": {"handle": "storage-boxes"}}}},
              {"id": "tool-boxes", "setting": {"title": "Tool Boxes", "url": {"type": {"id": "collection"}, "collection": {"handle": "tool-boxes"}}}},
              {"id": "cargo-nets-bags", "setting": {"title": "Cargo Nets, Bags & Straps", "url": {"type": {"id": "collection"}, "collection": {"handle": "cargo-nets-bags-straps"}}}},
              {"id": "straps-accessories", "setting": {"title": "Straps & Accessories", "url": {"type": {"id": "collection"}, "collection": {"handle": "straps-accessories"}}}}
            ]
          },
          {
            "id": "vehicle-accessories",
            "setting": {
              "item_layout": "enhanced",
              "title": "Vehicle Accessories",
              "description": "Vehicle enhancement and safety",
              "priority": 3,
              "url": {
                "type": {
                  "id": "collection",
                  "name": "Collection"
                },
                "collection": {
                  "handle": "vehicle-safety-maintenance",
                  "title": "Vehicle Accessories"
                }
              }
            },
            "menus": [
              {"id": "vehicle-safety", "setting": {"title": "Vehicle Safety & Maintenance", "url": {"type": {"id": "collection"}, "collection": {"handle": "vehicle-safety-maintenance"}}}},
              {"id": "roof-racks", "setting": {"title": "Roof Racks", "url": {"type": {"id": "collection"}, "collection": {"handle": "roof-racks"}}}},
              {"id": "towbars", "setting": {"title": "Towbars", "url": {"type": {"id": "collection"}, "collection": {"handle": "towbars"}}}},
              {"id": "towing-mirrors", "setting": {"title": "Towing Mirrors", "url": {"type": {"id": "collection"}, "collection": {"handle": "towing-mirrors"}}}},
              {"id": "side-mirror-extensions", "setting": {"title": "Side Mirror Towing Extensions", "url": {"type": {"id": "collection"}, "collection": {"handle": "side-mirror-towing-extensions"}}}},
              {"id": "car-seat-covers", "setting": {"title": "Car Seat Covers & Mats", "url": {"type": {"id": "collection"}, "collection": {"handle": "car-seat-covers-and-mats"}}}},
              {"id": "car-floor-mats", "setting": {"title": "Car Floor Mats", "url": {"type": {"id": "collection"}, "collection": {"handle": "car-floor-mats"}}}},
              {"id": "travel-bike-racks", "setting": {"title": "Travel Bike Racks", "url": {"type": {"id": "collection"}, "collection": {"handle": "travel-bike-racks-for-vehicles"}}}},
              {"id": "reverse-cameras", "setting": {"title": "Reverse Rear-View Cameras", "url": {"type": {"id": "collection"}, "collection": {"handle": "reverse-rear-view-cameras"}}}},
              {"id": "tpms", "setting": {"title": "TPMS", "url": {"type": {"id": "collection"}, "collection": {"handle": "tpms"}}}},
              {"id": "insect-screens", "setting": {"title": "Insect Radiator Screens", "url": {"type": {"id": "collection"}, "collection": {"handle": "insect-radiator-screens"}}}},
              {"id": "ozcam", "setting": {"title": "OzCam", "url": {"type": {"id": "collection"}, "collection": {"handle": "ozcam"}}}},
              {"id": "ozcharge", "setting": {"title": "OzCharge", "url": {"type": {"id": "collection"}, "collection": {"handle": "ozcharge"}}}},
              {"id": "ozsensor", "setting": {"title": "OzSensor", "url": {"type": {"id": "collection"}, "collection": {"handle": "ozsensor"}}}},
              {"id": "oznav", "setting": {"title": "OzNav", "url": {"type": {"id": "collection"}, "collection": {"handle": "oznav"}}}},
              {"id": "code-alarm", "setting": {"title": "Code Alarm", "url": {"type": {"id": "collection"}, "collection": {"handle": "code-alarm"}}}},
              {"id": "autel", "setting": {"title": "Autel", "url": {"type": {"id": "collection"}, "collection": {"handle": "autel"}}}},
              {"id": "schrader", "setting": {"title": "Schrader", "url": {"type": {"id": "collection"}, "collection": {"handle": "schrader"}}}},
              {"id": "tyredog", "setting": {"title": "Tyredog", "url": {"type": {"id": "collection"}, "collection": {"handle": "tyredog"}}}}
            ]
          },
          {
            "id": "fuel-fluids",
            "setting": {
              "item_layout": "enhanced",
              "title": "Fuel & Fluids",
              "description": "Fuel systems and accessories",
              "priority": 4,
              "url": {
                "type": {
                  "id": "collection",
                  "name": "Collection"
                },
                "collection": {
                  "handle": "fuel-tanks",
                  "title": "Fuel & Fluids"
                }
              }
            },
            "menus": [
              {"id": "fuel-tanks", "setting": {"title": "Fuel Tanks", "url": {"type": {"id": "collection"}, "collection": {"handle": "fuel-tanks"}}}},
              {"id": "fuel-tank-accessories", "setting": {"title": "Fuel Tank Accessories", "url": {"type": {"id": "collection"}, "collection": {"handle": "fuel-tank-accessories"}}}},
              {"id": "pressure-washers", "setting": {"title": "Pressure Washers", "url": {"type": {"id": "collection"}, "collection": {"handle": "pressure-washers"}}}},
              {"id": "load-weight-scales", "setting": {"title": "Load Weight Scales", "url": {"type": {"id": "collection"}, "collection": {"handle": "load-weight-scales"}}}}
            ]
          }
        ]
      },
      {
        "id": "marine-menu",
        "setting": {
          "item_layout": "enhanced",
          "submenu_type": "mega",
          "submenu_mega_position": "fullwidth",
          "title": "Marine",
          "description": "Professional marine equipment and accessories",
          "submenu_tab_position": "left",
          "priority": 5
        },
        "menus": [
          {
            "id": "boating-gear",
            "setting": {
              "item_layout": "enhanced",
              "title": "Boating",
              "description": "Essential boating equipment",
              "priority": 1,
              "url": {
                "type": {
                  "id": "collection",
                  "name": "Collection"
                },
                "collection": {
                  "handle": "boating",
                  "title": "Boating"
                }
              }
            },
            "menus": [
              {"id": "marine", "setting": {"title": "All Marine", "url": {"type": {"id": "collection"}, "collection": {"handle": "marine"}}}},
              {"id": "boating", "setting": {"title": "All Boating", "url": {"type": {"id": "collection"}, "collection": {"handle": "boating"}}}},
              {"id": "boat-covers", "setting": {"title": "Boat Covers", "url": {"type": {"id": "collection"}, "collection": {"handle": "boat-covers"}}}},
              {"id": "boat-anchors", "setting": {"title": "Boat Anchors", "url": {"type": {"id": "collection"}, "collection": {"handle": "boat-anchors"}}}},
              {"id": "boat-seats", "setting": {"title": "Boat Seats", "url": {"type": {"id": "collection"}, "collection": {"handle": "boat-seats"}}}},
              {"id": "boat-ladders", "setting": {"title": "Boat Ladders", "url": {"type": {"id": "collection"}, "collection": {"handle": "boat-ladders"}}}},
              {"id": "boat-winches", "setting": {"title": "Boat Winches", "url": {"type": {"id": "collection"}, "collection": {"handle": "boat-winches"}}}},
              {"id": "boat-trailer", "setting": {"title": "Boat Trailer", "url": {"type": {"id": "collection"}, "collection": {"handle": "boat-trailer"}}}},
              {"id": "anchors-docking", "setting": {"title": "Anchors & Docking", "url": {"type": {"id": "collection"}, "collection": {"handle": "anchors-and-docking"}}}},
              {"id": "fenders", "setting": {"title": "Fenders", "url": {"type": {"id": "collection"}, "collection": {"handle": "fenders"}}}},
              {"id": "life-jackets", "setting": {"title": "Life Jackets", "url": {"type": {"id": "collection"}, "collection": {"handle": "life-jackets"}}}},
              {"id": "marine-led-lights", "setting": {"title": "Marine LED Boat Lights", "url": {"type": {"id": "collection"}, "collection": {"handle": "marine-led-boat-lights"}}}},
              {"id": "bimini-canopy", "setting": {"title": "Bimini Canopy", "url": {"type": {"id": "collection"}, "collection": {"handle": "bimini-canopy"}}}},
              {"id": "wading-screens", "setting": {"title": "Wading Screens", "url": {"type": {"id": "collection"}, "collection": {"handle": "wading-screens"}}}}
            ]
          },
          {
            "id": "watersports",
            "setting": {
              "item_layout": "enhanced",
              "title": "Watersports",
              "description": "Fun on the water",
              "priority": 2,
              "url": {
                "type": {
                  "id": "collection",
                  "name": "Collection"
                },
                "collection": {
                  "handle": "watersports",
                  "title": "Watersports"
                }
              }
            },
            "menus": [
              {"id": "watersports", "setting": {"title": "All Watersports", "url": {"type": {"id": "collection"}, "collection": {"handle": "watersports"}}}},
              {"id": "surf-swim-paddle", "setting": {"title": "Surf, Swim & Paddle", "url": {"type": {"id": "collection"}, "collection": {"handle": "surf-swim-paddle"}}}},
              {"id": "kayaks", "setting": {"title": "Kayaks", "url": {"type": {"id": "collection"}, "collection": {"handle": "kayaks"}}}},
              {"id": "kayak-trolleys", "setting": {"title": "Kayak Trolleys", "url": {"type": {"id": "collection"}, "collection": {"handle": "kayak-trolleys"}}}},
              {"id": "kayak-racks", "setting": {"title": "Kayak Racks", "url": {"type": {"id": "collection"}, "collection": {"handle": "kayak-racks"}}}},
              {"id": "surfboards", "setting": {"title": "Surfboards", "url": {"type": {"id": "collection"}, "collection": {"handle": "surfboards"}}}},
              {"id": "stand-up-paddleboard", "setting": {"title": "Stand Up Paddleboard", "url": {"type": {"id": "collection"}, "collection": {"handle": "stand-up-paddleboard"}}}},
              {"id": "inflatable-boats", "setting": {"title": "Inflatable Boats", "url": {"type": {"id": "collection"}, "collection": {"handle": "inflatable-boats"}}}},
              {"id": "outboard-motors", "setting": {"title": "Outboard Motors", "url": {"type": {"id": "collection"}, "collection": {"handle": "outboard-motors"}}}},
              {"id": "paddles-oars", "setting": {"title": "Paddles & Oars", "url": {"type": {"id": "collection"}, "collection": {"handle": "paddles-oars"}}}},
              {"id": "waterbikes", "setting": {"title": "Waterbikes", "url": {"type": {"id": "collection"}, "collection": {"handle": "waterbikes"}}}},
              {"id": "floating-mats", "setting": {"title": "Floating Mats", "url": {"type": {"id": "collection"}, "collection": {"handle": "floating-mats"}}}},
              {"id": "swimming-snorkels", "setting": {"title": "Swimming Snorkels", "url": {"type": {"id": "collection"}, "collection": {"handle": "swimming-snorkels"}}}}
            ]
          },
          {
            "id": "fishing",
            "setting": {
              "item_layout": "enhanced",
              "title": "Fishing",
              "description": "Complete fishing solutions",
              "priority": 3,
              "url": {
                "type": {
                  "id": "collection",
                  "name": "Collection"
                },
                "collection": {
                  "handle": "fishing",
                  "title": "Fishing"
                }
              }
            },
            "menus": [
              {"id": "fishing", "setting": {"title": "All Fishing", "url": {"type": {"id": "collection"}, "collection": {"handle": "fishing"}}}},
              {"id": "fishing-combos", "setting": {"title": "Fishing Combos", "url": {"type": {"id": "collection"}, "collection": {"handle": "fishing-combos"}}}},
              {"id": "fishing-rods", "setting": {"title": "Fishing Rods", "url": {"type": {"id": "collection"}, "collection": {"handle": "fishing-rods"}}}},
              {"id": "fishing-reels", "setting": {"title": "Fishing Reels", "url": {"type": {"id": "collection"}, "collection": {"handle": "fishing-reels"}}}},
              {"id": "fishing-line", "setting": {"title": "Fishing Line", "url": {"type": {"id": "collection"}, "collection": {"handle": "fishing-line"}}}},
              {"id": "fishing-hooks", "setting": {"title": "Fishing Hooks", "url": {"type": {"id": "collection"}, "collection": {"handle": "fishing-hooks"}}}},
              {"id": "lures", "setting": {"title": "Lures", "url": {"type": {"id": "collection"}, "collection": {"handle": "lures"}}}},
              {"id": "tackle-boxes", "setting": {"title": "Tackle Boxes", "url": {"type": {"id": "collection"}, "collection": {"handle": "tackle-boxes"}}}},
              {"id": "nets-traps", "setting": {"title": "Nets & Traps", "url": {"type": {"id": "collection"}, "collection": {"handle": "nets-traps"}}}},
              {"id": "sinkers-moulds", "setting": {"title": "Sinkers & Moulds", "url": {"type": {"id": "collection"}, "collection": {"handle": "sinkers-moulds"}}}},
              {"id": "terminal-tackle", "setting": {"title": "Terminal Tackle", "url": {"type": {"id": "collection"}, "collection": {"handle": "terminal-tackle"}}}},
              {"id": "fishing-storage", "setting": {"title": "Fishing Storage", "url": {"type": {"id": "collection"}, "collection": {"handle": "fishing-storage"}}}},
              {"id": "fishing-tools", "setting": {"title": "Fishing Tools", "url": {"type": {"id": "collection"}, "collection": {"handle": "fishing-tools"}}}},
              {"id": "nets-gaffs-pumps", "setting": {"title": "Nets, Gaffs & Pumps", "url": {"type": {"id": "collection"}, "collection": {"handle": "nets-gaffs-pumps"}}}},
              {"id": "fishing-clothing-apparel", "setting": {"title": "Fishing Clothing & Apparel", "url": {"type": {"id": "collection"}, "collection": {"handle": "fishing-clothing-apparel"}}}},
              {"id": "fishing-gift-ideas", "setting": {"title": "Fishing Gift Ideas", "url": {"type": {"id": "collection"}, "collection": {"handle": "fishing-gift-ideas"}}}},
              {"id": "fishing-shade", "setting": {"title": "Fishing Shade", "url": {"type": {"id": "collection"}, "collection": {"handle": "fishing-shade"}}}}
            ]
          }
        ]
      },
      {
        "id": "electrical-menu",
        "setting": {
          "item_layout": "enhanced",
          "submenu_type": "mega",
          "submenu_mega_position": "fullwidth",
          "title": "Electrical",
          "description": "Complete power and electrical solutions",
          "submenu_tab_position": "left",
          "priority": 6
        },
        "menus": [
          {
            "id": "batteries-power",
            "setting": {
              "item_layout": "enhanced",
              "title": "Batteries & Power Storage",
              "description": "Power storage solutions",
              "priority": 1,
              "url": {
                "type": {
                  "id": "collection",
                  "name": "Collection"
                },
                "collection": {
                  "handle": "all-batteries",
                  "title": "Batteries & Power"
                }
              }
            },
            "menus": [
              {"id": "electrical", "setting": {"title": "All Electrical", "url": {"type": {"id": "collection"}, "collection": {"handle": "electrical"}}}},
              {"id": "electrical-battery-solar", "setting": {"title": "Electrical, Battery & Solar", "url": {"type": {"id": "collection"}, "collection": {"handle": "electrical-battery-solar"}}}},
              {"id": "batteries-deep-cycle", "setting": {"title": "Batteries, Deep Cycle", "url": {"type": {"id": "collection"}, "collection": {"handle": "batteries-deep-cycle-batteries"}}}},
              {"id": "all-batteries", "setting": {"title": "All Batteries", "url": {"type": {"id": "collection"}, "collection": {"handle": "all-batteries"}}}},
              {"id": "lithium-batteries", "setting": {"title": "Lithium LiFePO4 Batteries", "url": {"type": {"id": "collection"}, "collection": {"handle": "lithium-lifep04-batteries"}}}},
              {"id": "agm-batteries", "setting": {"title": "AGM Batteries", "url": {"type": {"id": "collection"}, "collection": {"handle": "agm-batteries"}}}},
              {"id": "gel-batteries", "setting": {"title": "Gel Deep Cycle Batteries", "url": {"type": {"id": "collection"}, "collection": {"handle": "gel-deep-cycle-batteries"}}}},
              {"id": "lead-carbon-batteries", "setting": {"title": "Lead Carbon Batteries", "url": {"type": {"id": "collection"}, "collection": {"handle": "lead-carbon-batteries"}}}},
              {"id": "battery-solar-accessories", "setting": {"title": "Battery & Solar Accessories", "url": {"type": {"id": "collection"}, "collection": {"handle": "battery-solar-accessories"}}}},
              {"id": "battery-boxes", "setting": {"title": "Battery Boxes", "url": {"type": {"id": "collection"}, "collection": {"handle": "battery-boxes"}}}},
              {"id": "battery-monitors", "setting": {"title": "Battery Monitors", "url": {"type": {"id": "collection"}, "collection": {"handle": "battery-monitors"}}}},
              {"id": "battery-management", "setting": {"title": "Battery Management Systems", "url": {"type": {"id": "collection"}, "collection": {"handle": "battery-management-systems"}}}},
              {"id": "battery-control-panels", "setting": {"title": "Battery Control Panels", "url": {"type": {"id": "collection"}, "collection": {"handle": "battery-control-panels"}}}},
              {"id": "dual-battery-systems", "setting": {"title": "Dual Battery Systems", "url": {"type": {"id": "collection"}, "collection": {"handle": "dual-battey-systems"}}}},
              {"id": "battery-isolators", "setting": {"title": "Battery Isolators", "url": {"type": {"id": "collection"}, "collection": {"handle": "battery-isolators"}}}},
              {"id": "jump-start-packs", "setting": {"title": "Jump Start Battery Packs", "url": {"type": {"id": "collection"}, "collection": {"handle": "jump-start-battery-packs"}}}},
              {"id": "jumper-leads", "setting": {"title": "Jumper Leads", "url": {"type": {"id": "collection"}, "collection": {"handle": "jumper-leads"}}}},
              {"id": "portable-power-packs", "setting": {"title": "Portable Power Battery Packs", "url": {"type": {"id": "collection"}, "collection": {"handle": "portable-power-battery-packs"}}}},
              {"id": "peak-power-packs", "setting": {"title": "Peak Power Packs", "url": {"type": {"id": "collection"}, "collection": {"handle": "peak-power-packs"}}}},
              {"id": "portable-generators", "setting": {"title": "Portable Camping Power Generators", "url": {"type": {"id": "collection"}, "collection": {"handle": "portable-camping-power-generators"}}}},
              {"id": "petrol-generators", "setting": {"title": "Petrol Inverter Generators", "url": {"type": {"id": "collection"}, "collection": {"handle": "petrol-inverter-generators"}}}},
              {"id": "petrol-powered-generators", "setting": {"title": "Petrol Powered Inverter Generators", "url": {"type": {"id": "collection"}, "collection": {"handle": "petrol-powered-inverter-generators"}}}}
            ]
          },
          {
            "id": "solar-power",
            "setting": {
              "item_layout": "enhanced",
              "title": "Solar Power Systems",
              "description": "Complete solar solutions",
              "priority": 2,
              "url": {
                "type": {
                  "id": "collection",
                  "name": "Collection"
                },
                "collection": {
                  "handle": "fixed-solar-panels",
                  "title": "Solar Power"
                }
              }
            },
            "menus": [
              {"id": "fixed-solar-panels", "setting": {"title": "Fixed Solar Panels", "url": {"type": {"id": "collection"}, "collection": {"handle": "fixed-solar-panels"}}}},
              {"id": "portable-flexible-solar", "setting": {"title": "Portable & Flexible Solar Panels", "url": {"type": {"id": "collection"}, "collection": {"handle": "portable-flexible-solar-panels"}}}},
              {"id": "solar-blankets", "setting": {"title": "Solar Blankets", "url": {"type": {"id": "collection"}, "collection": {"handle": "solar-blankets"}}}},
              {"id": "solar-controllers", "setting": {"title": "Solar Controllers & Regulators", "url": {"type": {"id": "collection"}, "collection": {"handle": "solar-controllers-regulators"}}}},
              {"id": "solar-power-controllers", "setting": {"title": "Solar Power Controllers", "url": {"type": {"id": "collection"}, "collection": {"handle": "solar-power-controllers"}}}},
              {"id": "mppt-controllers", "setting": {"title": "MPPT Solar Controllers", "url": {"type": {"id": "collection"}, "collection": {"handle": "mppt-solar-controllers"}}}},
              {"id": "pwm-controllers", "setting": {"title": "PWM Solar Controllers", "url": {"type": {"id": "collection"}, "collection": {"handle": "pwm-solar-controllers"}}}},
              {"id": "solar-panel-mounts", "setting": {"title": "Solar Panel Mounts", "url": {"type": {"id": "collection"}, "collection": {"handle": "solar-panel-mounts"}}}},
              {"id": "solar-accessories", "setting": {"title": "Solar Accessories", "url": {"type": {"id": "collection"}, "collection": {"handle": "solar-accessories"}}}},
              {"id": "solar-cables", "setting": {"title": "Solar Cables", "url": {"type": {"id": "collection"}, "collection": {"handle": "solar-cables"}}}},
              {"id": "solar-connectors", "setting": {"title": "Solar Connectors", "url": {"type": {"id": "collection"}, "collection": {"handle": "solar-connectors"}}}},
              {"id": "kt-solar", "setting": {"title": "KT Solar", "url": {"type": {"id": "collection"}, "collection": {"handle": "kt-solar"}}}}
            ]
          },
          {
            "id": "power-management",
            "setting": {
              "item_layout": "enhanced",
              "title": "Power Management & Charging",
              "description": "Complete power management solutions",
              "priority": 3,
              "url": {
                "type": {
                  "id": "collection",
                  "name": "Collection"
                },
                "collection": {
                  "handle": "12-volt-battery-chargers",
                  "title": "Power Management"
                }
              }
            },
            "menus": [
              {"id": "12v-battery-chargers", "setting": {"title": "12 Volt Battery Chargers", "url": {"type": {"id": "collection"}, "collection": {"handle": "12-volt-battery-chargers"}}}},
              {"id": "24v-battery-chargers", "setting": {"title": "24 Volt Battery Chargers", "url": {"type": {"id": "collection"}, "collection": {"handle": "24-volt-battery-chargers"}}}},
              {"id": "48v-battery-chargers", "setting": {"title": "48 Volt Battery Chargers", "url": {"type": {"id": "collection"}, "collection": {"handle": "48-volt-battery-chargers"}}}},
              {"id": "ac-dc-chargers", "setting": {"title": "AC to DC Battery Chargers", "url": {"type": {"id": "collection"}, "collection": {"handle": "ac-to-dc-battery-chargers"}}}},
              {"id": "marine-battery-chargers", "setting": {"title": "Marine Battery Charger", "url": {"type": {"id": "collection"}, "collection": {"handle": "marine-battery-charger"}}}},
              {"id": "12v-dc-dc-chargers", "setting": {"title": "12 Volt DC DC Chargers", "url": {"type": {"id": "collection"}, "collection": {"handle": "12-volt-dc-dc-chargers"}}}},
              {"id": "24v-dc-dc-chargers", "setting": {"title": "24 Volt DC DC Chargers", "url": {"type": {"id": "collection"}, "collection": {"handle": "24-volt-dc-dc-chargers"}}}},
              {"id": "dc-dc-power-converters", "setting": {"title": "DC-DC Power Converters", "url": {"type": {"id": "collection"}, "collection": {"handle": "dc-dc-power-converters"}}}},
              {"id": "12v-inverter-chargers", "setting": {"title": "12 Volt Inverter Chargers", "url": {"type": {"id": "collection"}, "collection": {"handle": "12-volt-inverter-chargers"}}}},
              {"id": "24v-inverter-chargers", "setting": {"title": "24 Volt Inverter Chargers", "url": {"type": {"id": "collection"}, "collection": {"handle": "24-volt-inverter-chargers"}}}},
              {"id": "48v-inverter-chargers", "setting": {"title": "48 Volt Inverter Chargers", "url": {"type": {"id": "collection"}, "collection": {"handle": "48-volt-inverter-chargers"}}}},
              {"id": "inverter-chargers", "setting": {"title": "Inverter Chargers", "url": {"type": {"id": "collection"}, "collection": {"handle": "inverter-chargers"}}}},
              {"id": "automatic-transfer-switches", "setting": {"title": "Automatic Transfer Switches", "url": {"type": {"id": "collection"}, "collection": {"handle": "automatic-transfer-switches"}}}}
            ]
          },
          {
            "id": "power-inverters",
            "setting": {
              "item_layout": "enhanced",
              "title": "Power Inverters & Converters",
              "description": "Convert and transform power efficiently",
              "priority": 4,
              "url": {
                "type": {
                  "id": "collection",
                  "name": "Collection"
                },
                "collection": {
                  "handle": "12-volt-dc-to-ac-inverters",
                  "title": "Power Inverters"
                }
              }
            },
            "menus": [
              {"id": "12v-dc-ac-inverters", "setting": {"title": "12 Volt DC to AC Inverters", "url": {"type": {"id": "collection"}, "collection": {"handle": "12-volt-dc-to-ac-inverters"}}}},
              {"id": "24v-dc-ac-inverters", "setting": {"title": "24 Volt DC to AC Inverters", "url": {"type": {"id": "collection"}, "collection": {"handle": "24-volt-dc-to-ac-inverters"}}}},
              {"id": "dc-ac-inverters", "setting": {"title": "DC to AC Power Inverters", "url": {"type": {"id": "collection"}, "collection": {"handle": "dc-to-ac-power-inverters"}}}},
              {"id": "12v-power-converters", "setting": {"title": "12 Volt Power Converters", "url": {"type": {"id": "collection"}, "collection": {"handle": "12-volt-power-converters"}}}},
              {"id": "24v-power-converters", "setting": {"title": "24 Volt Power Converters", "url": {"type": {"id": "collection"}, "collection": {"handle": "24-volt-power-converters"}}}},
              {"id": "48v-power-converters", "setting": {"title": "48 Volt Power Converters", "url": {"type": {"id": "collection"}, "collection": {"handle": "48-volt-power-converters"}}}},
              {"id": "110v-power-converters", "setting": {"title": "110 Volt Power Converters", "url": {"type": {"id": "collection"}, "collection": {"handle": "110-volt-power-converters"}}}},
              {"id": "240v-adapters", "setting": {"title": "240V to 12/24V Power Adapters", "url": {"type": {"id": "collection"}, "collection": {"handle": "240v-to-12-24v-power-adapters"}}}},
              {"id": "transformers-isolators", "setting": {"title": "Transformers & Isolators", "url": {"type": {"id": "collection"}, "collection": {"handle": "transformers-isolators"}}}},
              {"id": "power-distribution", "setting": {"title": "Power Distribution Systems", "url": {"type": {"id": "collection"}, "collection": {"handle": "power-distribution-systems"}}}}
            ]
          },
          {
            "id": "electrical-accessories",
            "setting": {
              "item_layout": "enhanced",
              "title": "Electrical Accessories & Wiring",
              "description": "Complete electrical accessories and components",
              "priority": 5,
              "url": {
                "type": {
                  "id": "collection",
                  "name": "Collection"
                },
                "collection": {
                  "handle": "wiring",
                  "title": "Electrical Accessories"
                }
              }
            },
            "menus": [
              {"id": "wiring", "setting": {"title": "Wiring", "url": {"type": {"id": "collection"}, "collection": {"handle": "wiring"}}}},
              {"id": "fuses-holders", "setting": {"title": "Fuses & Fuse Holders", "url": {"type": {"id": "collection"}, "collection": {"handle": "fuses-fuse-holders"}}}},
              {"id": "fuse-holders", "setting": {"title": "Fuse & Fuse Holders", "url": {"type": {"id": "collection"}, "collection": {"handle": "fuse-fuse-holders"}}}},
              {"id": "sockets-plugs", "setting": {"title": "Sockets, Plugs & Mounts", "url": {"type": {"id": "collection"}, "collection": {"handle": "sockets-plugs-mounts"}}}},
              {"id": "shunts-cables", "setting": {"title": "Shunts, Power & Data Cables", "url": {"type": {"id": "collection"}, "collection": {"handle": "shunts-power-data-cables"}}}},
              {"id": "silicones-sealants", "setting": {"title": "Silicones & Sealants", "url": {"type": {"id": "collection"}, "collection": {"handle": "silicones-sealants"}}}},
              {"id": "silicones-cleaning", "setting": {"title": "Silicone's & Cleaning Solutions", "url": {"type": {"id": "collection"}, "collection": {"handle": "silicones-cleaning-solutions"}}}}
            ]
          },
          {
            "id": "premium-electrical-brands",
            "setting": {
              "item_layout": "enhanced",
              "title": "Premium Electrical Brands",
              "description": "Industry-leading electrical brands",
              "priority": 6,
              "url": {
                "type": {
                  "id": "collection",
                  "name": "Collection"
                },
                "collection": {
                  "handle": "redarc-electronics-australian-battery-management-systems",
                  "title": "Premium Brands"
                }
              }
            },
            "menus": [
              {"id": "redarc", "setting": {"title": "REDARC Electronics", "url": {"type": {"id": "collection"}, "collection": {"handle": "redarc-electronics-australian-battery-management-systems"}}}},
              {"id": "victron-energy", "setting": {"title": "Victron Energy", "url": {"type": {"id": "collection"}, "collection": {"handle": "victron-energy"}}}},
              {"id": "enerdrive", "setting": {"title": "Enerdrive", "url": {"type": {"id": "collection"}, "collection": {"handle": "enerdrive"}}}},
              {"id": "baintech", "setting": {"title": "Baintech", "url": {"type": {"id": "collection"}, "collection": {"handle": "baintech"}}}},
              {"id": "all-spark", "setting": {"title": "All Spark", "url": {"type": {"id": "collection"}, "collection": {"handle": "all-spark"}}}},
              {"id": "noco", "setting": {"title": "NOCO", "url": {"type": {"id": "collection"}, "collection": {"handle": "noco"}}}},
              {"id": "lokithor", "setting": {"title": "Lokithor", "url": {"type": {"id": "collection"}, "collection": {"handle": "lokithor"}}}},
              {"id": "powex", "setting": {"title": "PowEx", "url": {"type": {"id": "collection"}, "collection": {"handle": "powex"}}}},
              {"id": "sphere", "setting": {"title": "Sphere", "url": {"type": {"id": "collection"}, "collection": {"handle": "sphere"}}}},
              {"id": "zylux", "setting": {"title": "Zylux", "url": {"type": {"id": "collection"}, "collection": {"handle": "zylux"}}}}
            ]
          }
        ]
      },
      {
        "id": "outdoor-bbq-menu",
        "setting": {
          "item_layout": "enhanced",
          "submenu_type": "mega",
          "submenu_mega_position": "fullwidth",
          "title": "Outdoor & BBQ",
          "description": "Premium outdoor cooking and BBQ equipment",
          "submenu_tab_position": "left",
          "priority": 7
        },
        "menus": [
          {
            "id": "bbq-grills",
            "setting": {
              "item_layout": "enhanced",
              "title": "BBQ Grills & Smokers",
              "description": "Premium grilling and smoking equipment",
              "priority": 1,
              "url": {
                "type": {
                  "id": "collection",
                  "name": "Collection"
                },
                "collection": {
                  "handle": "bbq-grills",
                  "title": "BBQ Grills"
                }
              }
            },
            "menus": [
              {"id": "bbq-grills", "setting": {"title": "BBQ Grills", "url": {"type": {"id": "collection"}, "collection": {"handle": "bbq-grills"}}}},
              {"id": "portable-bbqs", "setting": {"title": "Portable BBQs", "url": {"type": {"id": "collection"}, "collection": {"handle": "portable-bbqs"}}}},
              {"id": "ceramic-grills", "setting": {"title": "Ceramic Grills", "url": {"type": {"id": "collection"}, "collection": {"handle": "ceramic-grills"}}}},
              {"id": "smokers", "setting": {"title": "Smokers", "url": {"type": {"id": "collection"}, "collection": {"handle": "smokers"}}}},
              {"id": "portable-smokers", "setting": {"title": "Portable Smokers", "url": {"type": {"id": "collection"}, "collection": {"handle": "portable-smokers"}}}},
              {"id": "digital-smokers", "setting": {"title": "Digital Electronic Smokers", "url": {"type": {"id": "collection"}, "collection": {"handle": "digital-electronic-smokers"}}}},
              {"id": "pellet-smokers", "setting": {"title": "Pellet Smokers", "url": {"type": {"id": "collection"}, "collection": {"handle": "pellet-smokers"}}}},
              {"id": "outdoor-cooking-systems", "setting": {"title": "Outdoor Cooking Systems", "url": {"type": {"id": "collection"}, "collection": {"handle": "outdoor-cooking-systems"}}}},
              {"id": "outdoor-kitchens", "setting": {"title": "Outdoor Kitchens", "url": {"type": {"id": "collection"}, "collection": {"handle": "outdoor-kitchens"}}}},
              {"id": "slide-out-kitchens", "setting": {"title": "Slide-Out Outdoor Kitchens", "url": {"type": {"id": "collection"}, "collection": {"handle": "slide-out-outdoor-kitchens"}}}}
            ]
          },
          {
            "id": "kamado-joe",
            "setting": {
              "item_layout": "enhanced",
              "title": "Kamado Joe Premium Grills",
              "description": "World's best ceramic cookers",
              "priority": 2,
              "url": {
                "type": {
                  "id": "collection",
                  "name": "Collection"
                },
                "collection": {
                  "handle": "kamado-joe",
                  "title": "Kamado Joe"
                }
              }
            },
            "menus": [
              {"id": "kamado-joe", "setting": {"title": "KAMADO JOE®", "url": {"type": {"id": "collection"}, "collection": {"handle": "kamado-joe"}}}},
              {"id": "kamado-joe-accessories", "setting": {"title": "Kamado Joe Accessories", "url": {"type": {"id": "collection"}, "collection": {"handle": "kamado-joe-accessories"}}}}
            ]
          },
          {
            "id": "masterbuilt-camp-chef",
            "setting": {
              "item_layout": "enhanced",
              "title": "Masterbuilt & Camp Chef",
              "description": "Premium outdoor cooking brands",
              "priority": 3,
              "url": {
                "type": {
                  "id": "collection",
                  "name": "Collection"
                },
                "collection": {
                  "handle": "masterbuilt",
                  "title": "Masterbuilt & Camp Chef"
                }
              }
            },
            "menus": [
              {"id": "masterbuilt", "setting": {"title": "Masterbuilt", "url": {"type": {"id": "collection"}, "collection": {"handle": "masterbuilt"}}}},
              {"id": "masterbuilt-gravity", "setting": {"title": "Masterbuilt Gravity Series", "url": {"type": {"id": "collection"}, "collection": {"handle": "masterbuilt-gravity-series"}}}},
              {"id": "camp-chef", "setting": {"title": "Camp Chef", "url": {"type": {"id": "collection"}, "collection": {"handle": "camp-chef"}}}},
              {"id": "camp-chef-accessories", "setting": {"title": "Camp Chef Accessories", "url": {"type": {"id": "collection"}, "collection": {"handle": "camp-chef-accessories"}}}},
              {"id": "camp-chef-woodwind", "setting": {"title": "Camp Chef Woodwind Pro", "url": {"type": {"id": "collection"}, "collection": {"handle": "camp-chef-woodwind-pro"}}}}
            ]
          },
          {
            "id": "bbq-accessories-fuels",
            "setting": {
              "item_layout": "enhanced",
              "title": "BBQ Accessories & Fuels",
              "description": "Complete BBQ accessories and fuel solutions",
              "priority": 4,
              "url": {
                "type": {
                  "id": "collection",
                  "name": "Collection"
                },
                "collection": {
                  "handle": "bbq-grill-accessories",
                  "title": "BBQ Accessories"
                }
              }
            },
            "menus": [
              {"id": "bbq-grill-accessories", "setting": {"title": "BBQ Grill Accessories", "url": {"type": {"id": "collection"}, "collection": {"handle": "bbq-grill-accessories"}}}},
              {"id": "smoker-accessories", "setting": {"title": "Smoker Accessories", "url": {"type": {"id": "collection"}, "collection": {"handle": "smoker-accessories"}}}},
              {"id": "grill-thermometers", "setting": {"title": "Grill Thermometers", "url": {"type": {"id": "collection"}, "collection": {"handle": "grill-thermometers"}}}},
              {"id": "pellet-fuels", "setting": {"title": "Pellet Fuels", "url": {"type": {"id": "collection"}, "collection": {"handle": "pellet-fuels"}}}},
              {"id": "smoking-bbq-fuels", "setting": {"title": "Smoking & BBQ Fuels", "url": {"type": {"id": "collection"}, "collection": {"handle": "smoking-bbq-fuels"}}}},
              {"id": "fire-starters", "setting": {"title": "Fire Starters", "url": {"type": {"id": "collection"}, "collection": {"handle": "fire-starters"}}}},
              {"id": "bbq-rubs", "setting": {"title": "BBQ Rubs", "url": {"type": {"id": "collection"}, "collection": {"handle": "bbq-rubs"}}}},
              {"id": "lanes-bbq", "setting": {"title": "Lanes BBQ Seasoning & Sauces", "url": {"type": {"id": "collection"}, "collection": {"handle": "lanes-bbq-seasoning-sauces"}}}},
              {"id": "boars-night-out", "setting": {"title": "Boars Night Out Seasoning & Sauces", "url": {"type": {"id": "collection"}, "collection": {"handle": "boars-night-out-seasoning-sauces"}}}}
            ]
          },
          {
            "id": "featured-products",
            "setting": {
              "item_layout": "enhanced",
              "title": "Featured Products",
              "description": "Highlighted outdoor products",
              "priority": 5,
              "url": {
                "type": {
                  "id": "collection",
                  "name": "Collection"
                },
                "collection": {
                  "handle": "featured-products",
                  "title": "Featured Products"
                }
              }
            },
            "menus": [
              {"id": "featured-products", "setting": {"title": "Featured Products", "url": {"type": {"id": "collection"}, "collection": {"handle": "featured-products"}}}},
              {"id": "dlg-australia", "setting": {"title": "DLG Australia", "url": {"type": {"id": "collection"}, "collection": {"handle": "dlg-australia"}}}},
              {"id": "vidaxl", "setting": {"title": "vidaXL", "url": {"type": {"id": "collection"}, "collection": {"handle": "vidaxl"}}}},
              {"id": "widesea", "setting": {"title": "WIDESEA Outdoor", "url": {"type": {"id": "collection"}, "collection": {"handle": "widesea-outdoor"}}}}
            ]
          }
        ]
      },
      {
        "id": "brands-menu",
        "setting": {
          "item_layout": "enhanced",
          "submenu_type": "mega",
          "submenu_mega_position": "fullwidth",
          "title": "Brands",
          "description": "Premium outdoor and camping brands",
          "submenu_tab_position": "left",
          "priority": 8
        },
        "menus": [
          {
            "id": "brands-a-c",
            "setting": {
              "item_layout": "enhanced",
              "title": "Brands A-C",
              "description": "Premium brands from AeroPress to Cranky Croc",
              "priority": 1
            },
            "menus": [
              {"id": "aeropress", "setting": {"title": "AeroPress", "url": {"type": {"id": "collection"}, "collection": {"handle": "aeropress"}}}},
              {"id": "all-spark", "setting": {"title": "All Spark", "url": {"type": {"id": "collection"}, "collection": {"handle": "all-spark"}}}},
              {"id": "autel", "setting": {"title": "Autel", "url": {"type": {"id": "collection"}, "collection": {"handle": "autel"}}}},
              {"id": "baintech", "setting": {"title": "Baintech", "url": {"type": {"id": "collection"}, "collection": {"handle": "baintech"}}}},
              {"id": "cadence-car-audio", "setting": {"title": "Cadence Car Audio", "url": {"type": {"id": "collection"}, "collection": {"handle": "cadence-car-audio"}}}},
              {"id": "camec", "setting": {"title": "CAMEC", "url": {"type": {"id": "collection"}, "collection": {"handle": "camec"}}}},
              {"id": "camp-chef", "setting": {"title": "Camp Chef", "url": {"type": {"id": "collection"}, "collection": {"handle": "camp-chef"}}}},
              {"id": "carefree", "setting": {"title": "Carefree", "url": {"type": {"id": "collection"}, "collection": {"handle": "carefree"}}}},
              {"id": "coast-to-coast", "setting": {"title": "Coast to Coast Rv", "url": {"type": {"id": "collection"}, "collection": {"handle": "coast-to-coast"}}}},
              {"id": "code-alarm", "setting": {"title": "Code Alarm", "url": {"type": {"id": "collection"}, "collection": {"handle": "code-alarm"}}}},
              {"id": "cranky-croc", "setting": {"title": "Cranky Croc", "url": {"type": {"id": "collection"}, "collection": {"handle": "cranky-croc"}}}}
            ]
          },
          {
            "id": "brands-d-l",
            "setting": {
              "item_layout": "enhanced",
              "title": "Brands D-L",
              "description": "Premium brands from Dometic to Lokithor",
              "priority": 2
            },
            "menus": [
              {"id": "dometic", "setting": {"title": "Dometic", "url": {"type": {"id": "collection"}, "collection": {"handle": "dometic"}}}},
              {"id": "enerdrive", "setting": {"title": "Enerdrive", "url": {"type": {"id": "collection"}, "collection": {"handle": "enerdrive"}}}},
              {"id": "fiamma", "setting": {"title": "Fiamma", "url": {"type": {"id": "collection"}, "collection": {"handle": "fiamma"}}}},
              {"id": "force-ten", "setting": {"title": "Force Ten", "url": {"type": {"id": "collection"}, "collection": {"handle": "force-ten"}}}},
              {"id": "furrion", "setting": {"title": "Furrion", "url": {"type": {"id": "collection"}, "collection": {"handle": "furrion"}}}},
              {"id": "haven-tent", "setting": {"title": "Haven Tents", "url": {"type": {"id": "collection"}, "collection": {"handle": "haven-tent"}}}},
              {"id": "kamado-joe", "setting": {"title": "Kamado Joe", "url": {"type": {"id": "collection"}, "collection": {"handle": "kamado-joe"}}}},
              {"id": "kt-solar", "setting": {"title": "KT Solar", "url": {"type": {"id": "collection"}, "collection": {"handle": "kt-solar"}}}},
              {"id": "lokithor", "setting": {"title": "Lokithor", "url": {"type": {"id": "collection"}, "collection": {"handle": "lokithor"}}}}
            ]
          },
          {
            "id": "brands-m-r",
            "setting": {
              "item_layout": "enhanced",
              "title": "Brands M-R",
              "description": "Premium brands from Masterbuilt to Rosen Entertainment",
              "priority": 3
            },
            "menus": [
              {"id": "masterbuilt", "setting": {"title": "Masterbuilt", "url": {"type": {"id": "collection"}, "collection": {"handle": "masterbuilt"}}}},
              {"id": "milenco", "setting": {"title": "Milenco", "url": {"type": {"id": "collection"}, "collection": {"handle": "milenco"}}}},
              {"id": "mycoolman", "setting": {"title": "myCOOLMAN", "url": {"type": {"id": "collection"}, "collection": {"handle": "mycoolman"}}}},
              {"id": "national-luna", "setting": {"title": "National Luna", "url": {"type": {"id": "collection"}, "collection": {"handle": "national-luna"}}}},
              {"id": "noco", "setting": {"title": "NOCO", "url": {"type": {"id": "collection"}, "collection": {"handle": "noco"}}}},
              {"id": "nortent", "setting": {"title": "Nortent", "url": {"type": {"id": "collection"}, "collection": {"handle": "nortent"}}}},
              {"id": "ozcam", "setting": {"title": "OzCam", "url": {"type": {"id": "collection"}, "collection": {"handle": "ozcam"}}}},
              {"id": "ozcharge", "setting": {"title": "OzCharge", "url": {"type": {"id": "collection"}, "collection": {"handle": "ozcharge"}}}},
              {"id": "ozsensor", "setting": {"title": "OzSensor", "url": {"type": {"id": "collection"}, "collection": {"handle": "ozsensor"}}}},
              {"id": "oznav", "setting": {"title": "OzNav", "url": {"type": {"id": "collection"}, "collection": {"handle": "oznav"}}}},
              {"id": "powex", "setting": {"title": "PowEx", "url": {"type": {"id": "collection"}, "collection": {"handle": "powex"}}}},
              {"id": "redarc", "setting": {"title": "REDARC Electronics", "url": {"type": {"id": "collection"}, "collection": {"handle": "redarc-electronics-australian-battery-management-systems"}}}},
              {"id": "rosen-entertainment", "setting": {"title": "Rosen Entertainment", "url": {"type": {"id": "collection"}, "collection": {"handle": "rosen-entertainment"}}}}
            ]
          },
          {
            "id": "brands-s-z",
            "setting": {
              "item_layout": "enhanced",
              "title": "Brands S-Z",
              "description": "Premium brands from Schrader to Zylux",
              "priority": 4
            },
            "menus": [
              {"id": "schrader", "setting": {"title": "Schrader", "url": {"type": {"id": "collection"}, "collection": {"handle": "schrader"}}}},
              {"id": "sphere", "setting": {"title": "Sphere", "url": {"type": {"id": "collection"}, "collection": {"handle": "sphere"}}}},
              {"id": "thetford", "setting": {"title": "Thetford", "url": {"type": {"id": "collection"}, "collection": {"handle": "thetford"}}}},
              {"id": "tramontina-knives", "setting": {"title": "Tramontina", "url": {"type": {"id": "collection"}, "collection": {"handle": "tramontina-knives"}}}},
              {"id": "truma", "setting": {"title": "Truma", "url": {"type": {"id": "collection"}, "collection": {"handle": "truma"}}}},
              {"id": "tyredog", "setting": {"title": "Tyredog", "url": {"type": {"id": "collection"}, "collection": {"handle": "tyredog"}}}},
              {"id": "vango", "setting": {"title": "Vango", "url": {"type": {"id": "collection"}, "collection": {"handle": "vango"}}}},
              {"id": "victron-energy", "setting": {"title": "Victron Energy", "url": {"type": {"id": "collection"}, "collection": {"handle": "victron-energy"}}}},
              {"id": "weisshorn", "setting": {"title": "Weisshorn", "url": {"type": {"id": "collection"}, "collection": {"handle": "weisshorn"}}}},
              {"id": "winegard", "setting": {"title": "Winegard", "url": {"type": {"id": "collection"}, "collection": {"handle": "winegard"}}}},
              {"id": "x-bull", "setting": {"title": "X-BULL", "url": {"type": {"id": "collection"}, "collection": {"handle": "x-bull"}}}},
              {"id": "zylux", "setting": {"title": "Zylux", "url": {"type": {"id": "collection"}, "collection": {"handle": "zylux"}}}}
            ]
          }
        ]
      },
      {
        "id": "resources-menu",
        "setting": {
          "item_layout": "enhanced",
          "submenu_type": "mega",
          "submenu_mega_position": "fullwidth",
          "title": "Resources",
          "priority": 8,
          "url": {
            "type": {
              "id": "blog",
              "name": "Blog"
            },
            "blog": {
              "handle": "news",
              "title": "Blogs"
            }
          }
        },
        "menus": []
      },
      {
        "id": "campsite-menu",
        "setting": {
          "item_layout": "enhanced",
          "submenu_type": "none",
          "title": "Find Campsites",
          "priority": 9,
          "url": {
            "type": {
              "id": "external",
              "name": "External URL"
            },
            "external_url": "https://campingaustralia.com.au/apps/campsite-explorer"
          }
        },
        "menus": []
      }
    ]
  }
};

// Add validation and utility functions
window.customMenuData.utils = {
  validate: function() {
    console.log("🔍 Validating complete menu structure...");
    const data = window.customMenuData.data;
    let totalCollections = 0;
    
    data.megamenu.forEach((menu) => {
      if (menu.menus && Array.isArray(menu.menus)) {
        menu.menus.forEach((submenu) => {
          if (submenu.menus && Array.isArray(submenu.menus)) {
            totalCollections += submenu.menus.length;
          }
        });
      }
    });
    
    console.log(`✅ Menu validation complete:`);
    console.log(`   • Main menu items: ${data.megamenu.length}`);
    console.log(`   • Total collections: ${totalCollections}`);
    console.log(`   • The 6 Pillars: ✅ Camping, Caravan & RV, 4x4 & Touring, Marine, Electrical, Outdoor & BBQ`);
    console.log(`   • Additional: ✅ Blogs, Find Campsites`);
    console.log(`   • All Premium Brands: ✅ Integrated throughout categories`);
    console.log(`   • Status: Complete & Comprehensive`);
    
    return true;
  }
};


console.log("✅ COMPLETE Enhanced Mega Menu Data v10.0 loaded successfully!");
console.log("📋 All 6 pillars + Featured Brands + Blogs + Find Campsites");
console.log("📊 Run window.customMenuData.utils.validate() to validate structure");